import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-router-outlet',
  template: '<router-outlet></router-outlet>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouterOutletComponent {
}
